<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
import Logo from 'dashboard/components-next/icon/Logo.vue';
export default {
  components: { FeaturePlaceholder, Logo },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="chatmigo-empty-state-shell flex flex-col items-center justify-center h-full">
    <div class="chatmigo-empty-state-badge">
      <Logo class="size-14" />
    </div>
    <span class="chatmigo-empty-state-copy text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
